





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Customer } from '@/models/DTO/customer/customer.model';
import { PreferredContactMethodType } from '@/constants/preferred-contact-method-type';

@Component({
  computed: {
    showPhoneMethod(): boolean {
      if (!this.$props.customer) {
        return false;
      }

      return (
        this.$props.customer.preferredContactMethodId.toString() ===
        PreferredContactMethodType.Call
      );
    },
    showPhoneField(): boolean {
      if (!this.$props.customer) {
        return false;
      }

      return (
        this.$props.customer.preferredContactMethodId.toString() ===
          PreferredContactMethodType.Text ||
        this.$props.customer.preferredContactMethodId.toString() ===
          PreferredContactMethodType.Call
      );
    },
    showAddressFields(): boolean {
      if (!this.$props.customer) {
        return false;
      }

      return (
        this.$props.customer.preferredContactMethodId.toString() ===
        PreferredContactMethodType.Address
      );
    },
    showWebsiteField(): boolean {
      if (!this.$props.customer) {
        return false;
      }

      return (
        this.$props.customer.preferredContactMethodId.toString() ===
        PreferredContactMethodType.Website
      );
    }
  }
})
export default class DisplayOwnerDetailsComponent extends Vue {
  @Prop({
    required: true
  })
  public customer: Customer;

  public getGoogleMapsAddressLink(): string {
    const query = encodeURIComponent(
      `${this.customer.address1},${this.customer.city},${this.customer.state},${this.customer.zipCode}`
    );
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  }
}
